<template>
  <h2 class="mt-12 text-center font-headline text-h2 text-slate-darker">Snabba fakta om djuren</h2>
  <p class="py-2 text-center">Lär dig mer om djuren nedan. Svep för att se fler!</p>
  <div class="min-h-slider relative flex items-center md:mt-6">
    <client-only>
      <swiper
        v-if="animals.length > 0"
        :modules="modules"
        :slides-per-view="1.2"
        :space-between="16"
        :centered-slides="true"
        :loop="true"
        :breakpoints="breakpoints"
        :navigation="true"
      >
        <swiper-slide v-for="animal in animals" :key="animal._id">
          <content-card class="h-full" :animal="animal" :link="animal._path"></content-card>
        </swiper-slide>
      </swiper>
    </client-only>
  </div>
</template>

<script lang="ts">
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import type { PropType } from 'vue'
import type { ContentfulAnimal } from '@/types/contentful'

export default defineNuxtComponent({
  name: 'AnimalSlider',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    animals: { type: Array as PropType<ContentfulAnimal[]>, required: true },
  },
  data() {
    return {
      modules: [Navigation],
      breakpoints: {
        600: {
          slidesPerView: 1.9,
          spaceBetween: 50,
        },
        800: {
          slidesPerView: 2.5,
          spaceBetween: 50,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    }
  },
  methods: {},
})
</script>

<style lang="postcss" scoped>
.min-h-slider {
  min-height: min(400px, 80vw);
  @screen md {
    min-height: 300px;
  }
}
</style>
